import { render, staticRenderFns } from "./AxLayout3.vue?vue&type=template&id=670eda0f&scoped=true"
import script from "./AxLayout3.vue?vue&type=script&lang=ts"
export * from "./AxLayout3.vue?vue&type=script&lang=ts"
import style0 from "./AxLayout3.vue?vue&type=style&index=0&id=670eda0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670eda0f",
  null
  
)

export default component.exports